








































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalEdit/types";
import { SelectItem } from "@/types";
import EditDayChangePicker from "@/components/common/EditDayChangePicker.vue";

@Component({
  components: { EditDayChangePicker }
})
export default class BasicInfo3 extends Vue {
  @Prop() tab!: MedicalSpecification;
  @Prop() sex_items!: SelectItem[]; //性別選択アイテムリスト
}
